import { createContext, useContext, useMemo } from "react"
const JobProfileTableStyleContext = createContext()

/**
 * Proveedor de contexto para el plan anual.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes hijos.
 * @param {number} props.profileId - ID del perfil
 */
export function JobProfileTableStyleContextProvider({
	children,
	data = [],
	options = {},
	items,
}) {
	const datos = useMemo(
		() => ({
			data,
			options,
			items,
		}),
		[data, items, options]
	)
	return (
		<JobProfileTableStyleContext.Provider value={datos}>
			{children}
		</JobProfileTableStyleContext.Provider>
	)
}

/**
 * @typedef {Object} JobProfileTableStyleContextParams
 * @property {boolean} reload
 * @property {JobProfileType|null} jobProfile
 * @property {number|null} profileId
 * @property {function():void} setJobProfile - actualiza el la información del perfil
 * @property {function():void} refresh - actualiza el reload
 */

/**
 * Hook para acceder al contexto de creación del plan anual.
 * @returns {JobProfileTableStyleContextParams}
 */

export function JobProfileTableStyleContextContexts() {
	return useContext(JobProfileTableStyleContext)
}
